<div class="aca-admin aca-users">
  <aca-page-header [bare]="embedded" icon="group" [title]="'DMS.USERS_PAGE.DFEEA1' | translate" [subtitle]="'DMS.UI.2E83A8' | translate">
    <button type="button" class="aca-users__add" (click)="addUser()">
      <mat-icon>person_add</mat-icon>{{ 'DMS.USERS_PAGE.ADD_USER' | translate }}
    </button>
    <button type="button" class="aca-users__outline" (click)="exportCsv()" [disabled]="!visibleUsers().length">
      <mat-icon>download</mat-icon>{{ 'DMS.USERS_PAGE.2360B4' | translate }}
    </button>
  </aca-page-header>

  <!-- ── summary ────────────────────────────────────────────────────────── -->
  <div class="aca-users__stats" *ngIf="!failed()">
    <div class="aca-users__stat">
      <span class="aca-users__staticon aca-users__staticon--blue"><mat-icon>group</mat-icon></span>
      <span class="aca-users__stattext">
        <span class="aca-users__statlabel">{{ 'DMS.USERS_PAGE.935CA3' | translate }}</span>
        <span class="aca-users__statvalue">{{ totalCount() }}</span>
        <span class="aca-users__statunit">{{ 'DMS.USERS_PAGE.98AC16' | translate }}</span>
      </span>
    </div>

    <div class="aca-users__stat">
      <span class="aca-users__staticon aca-users__staticon--green"><mat-icon>check_circle</mat-icon></span>
      <span class="aca-users__stattext">
        <span class="aca-users__statlabel">{{ 'DMS.USERS_PAGE.985F0E' | translate }}</span>
        <span class="aca-users__statvalue">{{ enabledCount() }}</span>
        <span class="aca-users__statunit">{{ 'DMS.USERS_PAGE.98AC16' | translate }}</span>
      </span>
    </div>

    <div class="aca-users__stat">
      <span class="aca-users__staticon aca-users__staticon--amber"><mat-icon>block</mat-icon></span>
      <span class="aca-users__stattext">
        <span class="aca-users__statlabel">{{ 'DMS.USERS_PAGE.CD27D3' | translate }}</span>
        <span class="aca-users__statvalue">{{ disabledCount() }}</span>
        <span class="aca-users__statunit">{{ 'DMS.USERS_PAGE.98AC16' | translate }}</span>
      </span>
    </div>

    <div class="aca-users__stat">
      <span class="aca-users__staticon aca-users__staticon--purple"><mat-icon>admin_panel_settings</mat-icon></span>
      <span class="aca-users__stattext">
        <span class="aca-users__statlabel">{{ 'DMS.USERS_PAGE.5C278D' | translate }}</span>
        <span class="aca-users__statvalue">{{ adminCount() }}</span>
        <span class="aca-users__statunit">{{ 'DMS.USERS_PAGE.98AC16' | translate }}</span>
      </span>
    </div>
  </div>

  <!-- ── filters ────────────────────────────────────────────────────────── -->
  <div class="aca-users__filterbar">
    <form class="aca-users__searchfilter" (submit)="$event.preventDefault(); applyFilters()">
      <mat-icon>search</mat-icon>
      <input
        type="text"
        [placeholder]="'DMS.USERS_PAGE.AC4BBE' | translate"
        [(ngModel)]="term"
        name="term"
        (ngModelChange)="applyFilters()"
        autocomplete="off"
        data-automation-id="dms-users-search"
      />
    </form>

    <label class="aca-users__filter">
      <span class="aca-users__filterlabel">{{ 'DMS.USERS_PAGE.9A4FA6' | translate }}</span>
      <select class="aca-users__select" [(ngModel)]="status" name="status" (ngModelChange)="applyFilters()">
        <option value="all">{{ 'DMS.USERS_PAGE.56EFFD' | translate }}</option>
        <option value="enabled">{{ 'DMS.USERS_PAGE.985F0E' | translate }}</option>
        <option value="disabled">{{ 'DMS.USERS_PAGE.CD27D3' | translate }}</option>
      </select>
    </label>

    <button type="button" class="aca-users__link" (click)="clearFilters()">{{ 'DMS.USERS_PAGE.1C5830' | translate }}</button>
    <span class="aca-users__count"
      >{{ 'DMS.UI.1D31FB' | translate }} {{ visibleUsers().length }} {{ 'DMS.UI.F2DB2C' | translate }} {{ totalCount() }}
      {{ 'DMS.UI.E104A0' | translate }}</span
    >
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading() || working()" />

  <aca-page-state
    *ngIf="failed()"
    state="error"
    [title]="'DMS.USERS_PAGE.6BB3B3' | translate"
    [message]="failed()"
    [actionLabel]="'DMS.UI.324E7E' | translate"
    (action)="reload()"
  />

  <!-- ── table + detail ─────────────────────────────────────────────────── -->
  <div class="aca-users__body" [class.aca-users__body--split]="selected()" *ngIf="!failed()">
    <section class="aca-users__card">
      <aca-page-state
        *ngIf="!loading() && !visibleUsers().length"
        state="empty"
        icon="group"
        [title]="'DMS.USERS_PAGE.4B8F6E' | translate"
        [message]="'DMS.UI.FF98C0' | translate"
        [actionLabel]="'DMS.UI.864B57' | translate"
        (action)="clearFilters()"
      />

      <!-- the users ticked, and what can be done to all of them at once -->
      <div class="aca-users__bulkbar" *ngIf="checkedCount()" role="region" [attr.aria-label]="'DMS.BULK.ACTIONS' | translate">
        <span class="aca-users__bulkcount" aria-live="polite" data-automation-id="dms-users-bulk-count">{{
          'DMS.BULK.SELECTED' | translate: { count: checkedCount() }
        }}</span>
        <button
          type="button"
          class="aca-users__outline"
          (click)="setCheckedEnabled(true)"
          [disabled]="working() || loading()"
          data-automation-id="dms-users-bulk-enable"
        >
          <mat-icon>check_circle</mat-icon>{{ 'DMS.BULK.ENABLE' | translate }}
        </button>
        <button
          type="button"
          class="aca-users__danger"
          (click)="setCheckedEnabled(false)"
          [disabled]="working() || loading()"
          data-automation-id="dms-users-bulk-suspend"
        >
          <mat-icon>block</mat-icon>{{ 'DMS.BULK.SUSPEND' | translate }}
        </button>
        <button
          type="button"
          class="aca-users__outline"
          (click)="addCheckedToGroup()"
          [disabled]="working() || loading()"
          data-automation-id="dms-users-bulk-group"
        >
          <mat-icon>group_add</mat-icon>{{ 'DMS.BULK.ADD_TO_GROUP' | translate }}
        </button>
        <button type="button" class="aca-users__outline" (click)="exportChecked()" data-automation-id="dms-users-bulk-export">
          <mat-icon>download</mat-icon>{{ 'DMS.BULK.EXPORT' | translate }}
        </button>
        <button type="button" class="aca-users__link" (click)="clearChecks()" data-automation-id="dms-users-bulk-clear">
          {{ 'DMS.BULK.CLEAR' | translate }}
        </button>
      </div>

      <div class="aca-users__tablewrap" *ngIf="visibleUsers().length">
        <table class="aca-users__table">
          <thead>
            <tr>
              <th class="aca-users__th aca-users__th--check">
                <mat-checkbox
                  [checked]="allChecked()"
                  [indeterminate]="someChecked()"
                  (change)="toggleAllChecks()"
                  [attr.aria-label]="'DMS.BULK.SELECT_SHOWN' | translate"
                  data-automation-id="dms-users-select-all"
                />
              </th>
              <th class="aca-users__th aca-users__th--name">{{ 'DMS.USERS_PAGE.DFEEA1' | translate }}</th>
              <th class="aca-users__th">{{ 'DMS.USERS_PAGE.7F4210' | translate }}</th>
              <th class="aca-users__th">{{ 'DMS.USERS_PAGE.6CF08C' | translate }}</th>
              <th class="aca-users__th">{{ 'DMS.USERS_PAGE.EE4A25' | translate }}</th>
              <th class="aca-users__th">{{ 'DMS.USERS_PAGE.74B287' | translate }}</th>
              <th class="aca-users__th">{{ 'DMS.USERS_PAGE.2E8C46' | translate }}</th>
              <th class="aca-users__th aca-users__th--actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="aca-users__row"
              *ngFor="let user of visibleUsers(); trackBy: trackById"
              [class.aca-users__row--on]="selected()?.id === user.id"
              [class.aca-users__row--checked]="isChecked(user)"
              [attr.data-automation-id]="'dms-users-row-' + user.id"
              (click)="select(user)"
            >
              <td class="aca-users__td aca-users__td--check" (click)="$event.stopPropagation()">
                <mat-checkbox
                  [checked]="isChecked(user)"
                  (change)="toggleCheck(user)"
                  [attr.aria-label]="'DMS.BULK.SELECT_ROW' | translate: { name: user.displayName }"
                  [attr.data-automation-id]="'dms-users-select-' + user.id"
                />
              </td>
              <td class="aca-users__td aca-users__td--name">
                <span class="aca-users__avatar">{{ initials(user.displayName) }}</span>
                <span class="aca-users__namebox">
                  <span class="aca-users__name">{{ user.displayName }}</span>
                  <span class="aca-users__adminmark" *ngIf="user.isAdmin">{{ 'DMS.USERS_PAGE.5C278D' | translate }}</span>
                </span>
              </td>
              <td class="aca-users__td">
                <code class="aca-users__code">{{ user.id }}</code>
              </td>
              <td class="aca-users__td">{{ user.email || '—' }}</td>
              <td class="aca-users__td">{{ user.jobTitle || '—' }}</td>
              <td class="aca-users__td">{{ user.organization || '—' }}</td>
              <td class="aca-users__td">
                <span class="aca-users__chip" [class.aca-users__chip--on]="user.enabled" [class.aca-users__chip--off]="!user.enabled">
                  <span class="aca-users__dot"></span>
                  {{ user.enabled ? ('DMS.UI.216768' | translate) : ('DMS.UI.65B98F' | translate) }}
                </span>
              </td>
              <td class="aca-users__td aca-users__td--actions">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="rowMenu"
                  (click)="$event.stopPropagation()"
                  [matTooltip]="'DMS.USERS_PAGE.6D5E7B' | translate"
                  [attr.aria-label]="'DMS.USERS_PAGE.6D5E7B' | translate"
                >
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #rowMenu="matMenu">
                  <button mat-menu-item (click)="select(user)">
                    <mat-icon>person</mat-icon><span>{{ 'DMS.USERS_PAGE.FF9D41' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="changePassword(user)">
                    <mat-icon>key</mat-icon><span>{{ 'DMS.USERS_PAGE.EC9C6C' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="toggleEnabled(user)">
                    <mat-icon>{{ user.enabled ? 'block' : 'check_circle' }}</mat-icon>
                    <span>{{ user.enabled ? ('DMS.UI.5E0483' | translate) : ('DMS.UI.098289' | translate) }}</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- ── detail panel ─────────────────────────────────────────────────── -->
    <aside class="aca-users__panel" *ngIf="selected() as user">
      <header class="aca-users__panelhead">
        <h2 class="aca-users__paneltitle">{{ 'DMS.USERS_PAGE.CFAA49' | translate }}</h2>
        <button
          mat-icon-button
          (click)="closePanel()"
          [matTooltip]="'DMS.USERS_PAGE.96D79D' | translate"
          [attr.aria-label]="'DMS.USERS_PAGE.96D79D' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <div class="aca-users__identity">
        <span class="aca-users__avatar aca-users__avatar--lg">{{ initials(user.displayName) }}</span>
        <div class="aca-users__identitytext">
          <span class="aca-users__identityname">{{ user.displayName }}</span>
          <span class="aca-users__identitysub">{{ user.jobTitle || user.id }}</span>
          <span class="aca-users__chip" [class.aca-users__chip--on]="user.enabled" [class.aca-users__chip--off]="!user.enabled">
            <span class="aca-users__dot"></span>
            {{ user.enabled ? ('DMS.UI.216768' | translate) : ('DMS.UI.65B98F' | translate) }}
          </span>
        </div>
      </div>

      <div class="aca-users__fields">
        <div class="aca-users__field">
          <label for="u-first">{{ 'DMS.USERS_PAGE.0B1FCF' | translate }}</label>
          <input id="u-first" type="text" class="aca-users__input" [(ngModel)]="edit.firstName" name="firstName" />
        </div>
        <div class="aca-users__field">
          <label for="u-last">{{ 'DMS.USERS_PAGE.969106' | translate }}</label>
          <input id="u-last" type="text" class="aca-users__input" [(ngModel)]="edit.lastName" name="lastName" />
        </div>
        <div class="aca-users__field aca-users__field--full">
          <label for="u-email">{{ 'DMS.USERS_PAGE.6CF08C' | translate }}</label>
          <input id="u-email" type="email" class="aca-users__input" [(ngModel)]="edit.email" name="email" />
        </div>
        <div class="aca-users__field">
          <label for="u-job">{{ 'DMS.USERS_PAGE.EE4A25' | translate }}</label>
          <input id="u-job" type="text" class="aca-users__input" [(ngModel)]="edit.jobTitle" name="jobTitle" />
        </div>
        <div class="aca-users__field">
          <label for="u-org">{{ 'DMS.USERS_PAGE.74B287' | translate }}</label>
          <input id="u-org" type="text" class="aca-users__input" [(ngModel)]="edit.organization" name="organization" />
        </div>
        <div class="aca-users__field aca-users__field--full">
          <label for="u-id">{{ 'DMS.USERS_PAGE.7F4210' | translate }}</label>
          <input id="u-id" type="text" class="aca-users__input" [value]="user.id" readonly disabled />
        </div>
      </div>

      <section class="aca-users__groups">
        <h3 class="aca-users__grouptitle">
          {{ 'DMS.USERS_PAGE.06A277' | translate }}<span class="aca-users__groupcount" *ngIf="!groupsLoading()">({{ selectedGroups().length }})</span>
        </h3>
        <p class="aca-users__grouploading" *ngIf="groupsLoading()">{{ 'DMS.USERS_PAGE.D14A5E' | translate }}</p>
        <div class="aca-users__groupchips" *ngIf="!groupsLoading()">
          <span class="aca-users__groupchip" *ngFor="let group of selectedGroups(); trackBy: trackByGroupId">{{ group.displayName }}</span>
          <span class="aca-users__groupempty" *ngIf="!selectedGroups().length">{{ 'DMS.USERS_PAGE.23DB38' | translate }}</span>
        </div>
      </section>

      <div class="aca-users__panelactions">
        <button type="button" class="aca-users__danger" (click)="toggleEnabled(user)">
          <mat-icon>{{ user.enabled ? 'block' : 'check_circle' }}</mat-icon>
          {{ user.enabled ? ('DMS.UI.5E0483' | translate) : ('DMS.UI.098289' | translate) }}
        </button>
        <button type="button" class="aca-users__outline" (click)="changePassword(user)">
          <mat-icon>key</mat-icon>{{ 'DMS.USERS_PAGE.EC9C6C' | translate }}
        </button>
        <button type="button" class="aca-users__primary" (click)="save()" [disabled]="saving()">
          <mat-icon>save</mat-icon>
          {{ saving() ? ('DMS.UI.2C6DE1' | translate) : ('DMS.UI.6EA45A' | translate) }}
        </button>
      </div>
    </aside>
  </div>
</div>
